import React, {Component} from 'react';
import i18n from "../i18n";
import LandingView from "../views/LandingView";
import {withTranslation} from 'react-i18next';
import {withJobInformationApi, Loading, withStyleguide} from "cw-styleguide-react";

/**
 * LandingController.
 */
class LandingController extends Component {
  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataLoaded:false
    };
  }

  /**
   * componentDidMount.
   */
  componentDidMount() {

    this.props.jobInformationApiGetAboutJobsLandingPage(i18n.language, (response) => {
      this.setState({
        data: response.data,
        dataLoaded:true
      });

      console.log(response.data)
    }, (error) => {
console.log('ERRORS');
      let errors = FormUtility.processServerErrors(error, i18n);

      this.setState({
        messages: errors.messages,
        dataLoaded:false
      })
    });

      this.props.styleguide.setLanguageUrl( '');
  }

  /**
   * render.
   * @returns {JSX.Element}
   */
  render() {
    // We don't want to render the page until we have all the api data loaded.
    if (!this.state.dataLoaded) {
      return <Loading />
    }
    return <LandingView {...this.state}/>;
  }
}
export default withStyleguide(withJobInformationApi(withTranslation(['common', 'styleguide'])(LandingController)));
